export default __webpack_public_path__ + "media/images/logo-cybre-9b7c2de5a819feaf36403748a4d132dc.png";